import { useEffect, forwardRef } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';

import useLoginSelector from '../store/Slice/Login/LoginSelector';

const Page = forwardRef(({ children, title = '', refreshPageComponent, ...other }, ref) => {
  const navigate = useNavigate();
  const { LoginData } = useLoginSelector();

  // console.log('LoginData222', LoginData);

  useEffect(() => {
    if (!LoginData || LoginData?.status !== 'OK' || !LoginData?.jwt) {
      navigate('/', { replace: true });
    }
  }, [LoginData, navigate, refreshPageComponent]);

  if (!LoginData || !LoginData?.jwt) {
    return null; // or loader
  }

  return (
    <Box ref={ref} {...other}>
      <Helmet>{/* <title>{title}</title> */}</Helmet>
      {children}
    </Box>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default Page;
